import React, { useContext, useEffect, useState } from 'react'
import { Stack } from '@mui/material'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import Loader from '../../../../components/Loader'
import { userSelector } from '../../user/userSelectors'
import ConnexionInfo from '../components/connexionInfo/ConnexionInfo'
import { RefreshContext } from '../services/refresh/RefreshContext'
import PageLayout from '../../../../components/PageLayout'
import PartageConnexion from '../components/partageConnexion/PartageConnexion'
import UserService from '../../../../api/gerep/UserService'
import LocalStorage from '../../../../business/storage/LocalStorage'
import { getConjoint } from '../../../webservices/affiliation/affiliationSelector'

const PersonalConnexionPage = (
	{
		// @ts-ignore
		user,
		// @ts-ignore
		conjoint
	}
) => {
	const intl = useIntl()
	const { refreshing } = useContext(RefreshContext)
	const [userConjointAccess, setUserConjointAccess] = useState<any>(undefined)
	const [loading, setLoading] = useState<boolean>(true)


	useEffect(() => {
		setLoading(true)
		UserService.getUserConjointAccess(LocalStorage.getToken()).then((data: any) => {
			setUserConjointAccess(data)
		})
		.finally(() => setLoading(false))
	}, [])


	if ( loading || refreshing ) {
		return <Loader />
	}

	return (
		<PageLayout title={intl.formatMessage({ id: 'personalInfo.title' })}>
			<Stack direction="column" spacing="24px">
				<ConnexionInfo user={user} />
				{ !user.profil.compteConjoint && conjoint !== undefined &&
					<PartageConnexion userConjointAccess={userConjointAccess} conjoint={conjoint} setUserConjointAccess={setUserConjointAccess}/>
				}
			</Stack>
		</PageLayout>
	)
}


const mapStateToProps = (state: any) => ({
	user: userSelector(state),
	conjoint: getConjoint(state)
})

const actions = {

}

export default connect(
	mapStateToProps, actions
)(PersonalConnexionPage)
